export default {
        trails: { caption: "Skill up", link: '/' },
        sfplus: { caption: "Get inspired", link: '/sfplus' },
        connect: { caption: "Connect", link: '/community' },
        rewards: { caption: "Be rewarded", link: '/myrewards' },
        team: { caption: "Support", link: '/team' },
};